import { Controller } from "@hotwired/stimulus";

import tinymce from "tinymce/tinymce";
import "tinymce/models/dom";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/autoresize";
import "tinymce/skins/ui/oxide/skin.css";
import contentUiCss from "tinymce/skins/ui/oxide/content.css?inline";
import contentCss from "tinymce/skins/content/default/content.css?inline";

const TOOLBAR = "undo redo | bold italic | bullist numlist | link | removeformat";

tinymce.addI18n("da", {
  Undo: "Fortryd",
  Redo: "Gentag",
  Bold: "Fed",
  Italic: "Kursiv",
  "Bullet list": "Punktopstilling",
  "Numbered list": "Nummereret liste",
  "Insert/edit link": "Indsæt eller redigér link",
  "Clear formatting": "Fjern formatering",
  "Insert link": "Indsæt link",
  "Edit link": "Redigér link",
  "Remove link": "Fjern link",
  URL: "Adresse",
  "Text to display": "Tekst der vises",
  "Open link in...": "Åbn link i...",
  "Current window": "Samme vindue",
  "New window": "Nyt vindue",
  Save: "Gem",
  Cancel: "Annullér",
  Close: "Luk",
  None: "Ingen",
  "Paste or type a link": "Indsæt eller skriv et link",
});

export default class extends Controller {
  connect() {
    tinymce.init({
      target: this.element,
      language: "da",
      menubar: false,
      statusbar: false,
      branding: false,
      promotion: false,
      skin: false,
      content_css: false,
      content_style: `${contentUiCss}\n${contentCss}\nbody { font-family: system-ui, sans-serif; font-size: 15px; }`,
      plugins: "lists link autoresize",
      toolbar: TOOLBAR,
      valid_elements: "p,br,strong/b,em/i,u,ul,ol,li,a[href|title|target|rel],h3,h4,blockquote",
      autoresize_bottom_margin: 16,
      min_height: 220,
      setup: (editor) => {
        editor.on("change keyup", () => editor.save());
      },
    });
  }

  disconnect() {
    tinymce.get(this.element.id)?.remove();
  }
}
